export default __webpack_public_path__ + "static/media/KZ.Т.12.Е0718 black.cc2c9fe3.svg";